import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { personsSearchByNameOptions } from "@/queryOptions/persons";
import { updateQueryClientPersons } from "@/utils/queryClientUpdate";

export const usePersonNameQuery = (query: string) => {
  const queryClient = useQueryClient();
  const queryResult = useQuery(personsSearchByNameOptions(query));

  useEffect(() => {
    if (queryResult.data) {
      updateQueryClientPersons(queryClient, queryResult.data);
    }
  }, [queryResult.data, queryClient]);

  return queryResult;
};
